module.exports = __webpack_public_path__ + "img/slidebar-bg.c69a8bd7.png";